<template>
     <div class="content-wrappper">
         <div class="row contacts_main m-0">
            <div class="col-md-12 p-0" >
            </div>
            <div class="content-body">
          <div class="pb-24">
          <p class="m-0 support_title">{{ $t('support_label') }}</p>
           </div>
            <div class="row m-0 support_form">
            <div class="col-xs-12 col-sm-12 col-md-12 pl-24 pr-0 m-0" style="padding-top: 24px;">
              <!-- <div class="row m-0"> -->
                <div class="support_message ">
                    <span class="">{{ $t('supportText') }}</span>
                </div>
                <!-- </div> -->
                 <!-- <form @submit.prevent="submitForm"> -->
                    <div class="row m-0 form-group pl-8 pb-38">
                      <div class="login-input  "  style="width:524px">
                        <div for="subject" class="titles pb-7">{{$t('subject')}}</div>

                        <input
                          class="form-control login-input-box-without-icon landing-input-field"
                          type="text"
                          name="subject"
                          :placeholder="$t('enterSubject')"
                          v-model.trim="formData.subject"
                          :class="$v.formData.subject.$error ? 'invalid-border':''"
                          @keyup="checkUpdatedFields()"
                          @blur="$v.formData.subject.$touch()"
                          maxlength="100"
                        />
                         <div v-if="$v.formData.subject.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.formData.subject.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-if="!$v.formData.subject.minLength"
                          >{{$t('min2CharactersRequired')}}.</div>
                        </div>
                        </div>

                     </div>

                      <div class="row m-0 pl-8 pr-17">
                        <div class="col-md-12 col-xs-12 col-sm-12 pl-0 form-group">
                          <label class="titles pb-8">{{$t('message')}}</label>
                          <textarea
                            type="text"
                            class="message-box form-control"
                             v-model.trim="formData.message"
                             :class="$v.formData.message.$error ? 'invalid-border':''"
                             @keyup="checkUpdatedFields()"
                             @blur="$v.formData.message.$touch()"
                              :placeholder="$t('enterMessage')"
                          ></textarea>
                            <div v-if="$v.formData.message.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.formData.message.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-if="!$v.formData.message.minLength"
                          >{{$t('min2CharactersRequired')}}.</div>
                        </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 p-0"><hr class="lower-line" /></div>
                      <div class="row m-0 pl-8 pr-17">
                        <div class="col-md-12 col-xs-12 col-sm-12 pl-0">
                          <p class="support_message m-0">{{$t('addAttachmentBelow')}}</p>
                          <div class="upload-area" @drop.prevent.stop="getDroppedFile" @dragover.prevent.stop="onDragOver">
                            <div class="notify_message">
                                <li>
                                  {{ $t('fileUploadMessage1') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessage2') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessage3') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessage4') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessage5') }}
                                </li>
                            </div>
                            <div class="col-xs-12 col-sm-12 p-0 mb-8">
                              <input type="file" multiple ref="fileListUploaded" accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .xlsx, .xls, .ppt, .pptx" id="uploadFiles" class="hidden" @change="filesChange"/>
                              <div class="d-flex mt-20 ml-30">
                                <button for="uploadFiles" class="btn emergo-btn emergo-secondary-button d-flex align-center" @click="openFileUpload">
                                  {{ $t('upload') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="uploadedFiles && uploadedFiles.length">
                        <div class="col-xs-12 col-sm-12 col-md-12 p-0"><hr class="lower-line-inside " /></div>
                      <div class="files-main">
                      <div class="attachments-label">{{$t('FilesAttachedLabel')}}:</div>
                       <div class="col-xs-12 col-sm-12 col-md-12 p-0" >
                        <div id="attachments_table" >
                        <table class="table table-responsive registration-data" id="attachmentsDataList" >
                            <tr style="background-color: #E6E6E6; !important;">
                              <th style="width:80%" >
                                <div class="tableHeader cursor-pointer" @click="fileNameArrow = (-fileNameArrow), sortAddresses('name', fileNameArrow)">
                                  <div class="header-ellipsis header-title" :title="$t('FilesAttachedLabel')">{{$t('FilesAttachedLabel')}}</div>
                                  <div class="arrow" :class="fileNameArrow === 1 ? 'down-arrow ' : 'up-arrow '"></div>
                                </div>
                              </th>
                              <th></th>
                            </tr>
                          <tbody ref="tbodyBox" >
                            <tr class="viewRegistration"
                            :class="index%2===0?'table_data_part1':'table_data_part2'"
                            v-for="(file, index) in uploadedFiles" :key="index">
                            <td  class="ellipsis files-data" style="width:50%">
                             <div class=" ellipsis pl-0" :title="file.name">{{file.name}}</div>
                            </td>
                              <td class="ellipsis edit-icons ">
                                <div class=" d-flex justify-content-end pr-32" > <div>
                                    <button class="btn btn-delete-file pr-0 d-flex align-items-center" id="ptb-0" @click="checkfile(file)">
                                    <img src="/static/images/icons/Trash.svg" class="address-images pr-4" />{{$t('delete')}}</button>
                                    </div></div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        </div>
                      </div>
                      </div>
                    </template>
                    <div class="col-xs-12 col-sm-12 col-md-12 p-0"><hr class="lower-line mt-32" /></div>

                      <div class="footer d-flex col-xs-12 col-sm-12 col-md-12 justify-content-end d-flex-sm-end pl-0 pb-16">
                        <div class="col-xs-6 col-sm-6 com-md-16">
                      </div>
                      <div class="col-xs-6 col-sm-6 col-md-6 pr-0 col-gap-16 d-flex buttons">
                        <button type="button" class="btn cancel_ul_button" @click="goToDashboard()"
                        >{{$t('cancel')}} </button>
                        <button type="button" class="btn save_ul_button" :disabled="disableSaveButton" @click="submitForm()">{{$t('submit')}} </button>
                      </div>
                    </div>
                 <!-- </form> -->
            </div>
            </div>
           </div>
        </div>
         <loader :loadingStatus="loaderStatus"></loader>
    </div>
</template>

<script>
import $ from 'jquery';
import { required, minLength } from 'vuelidate/lib/validators';
import { saveSupportForm } from '../../apis/dashboard';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      errorMessage: '',
      formData: {
        subject: '',
        message: '',
      },
      disableSaveButton: true,
      loaderStatus: false,
      acceptedExtensions: ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'xlsx', 'xls', 'ppt', 'pptx'],
      uploadFieldName: 'file',
      uploadedFiles: [],
      isNotConaints: '',
      isDuplicate: false,
      fileNameArrow: 1,
      fileStatusArrow: 1
    };
  },
  components: {
    Loader
  },
  validations: {
    formData: {
      subject: {
        minLength: minLength(2),
        required,
      },
      message: {
        minLength: minLength(2),
        required,

      },
    },
  },
  async created() {
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },

  methods: {
    checkfile(file) {
      this.uploadedFiles = this.uploadedFiles.filter((each) => each.name !== file.name);
      this.$refs.fileListUploaded.value = '';
      this.checkUpdatedFields();
    },
    filesChange() {
      this.filesUploaded([...this.$refs.fileListUploaded.files]);
    },
    filesUploaded(fileList) {
      const fileInfo = this.uploadedFiles.filter((item) => fileList.find((f) => f.name.toLowerCase() === item.name.toLowerCase()));
      if (fileInfo.length) {
        fileList = fileList.filter((item) => fileInfo.every((f) => f.name.toLowerCase() !== item.name.toLowerCase()));
        this.$refs.fileListUploaded.value = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Alguns nomes de arquivo já existem' : 'Some file names already exist',
          group: 'custom-notification'
        });
      }
      fileList.forEach((file) => {
        const filename = file.name.substring(0, file.name.lastIndexOf('.'));
        const extN = file.name.split('.').pop();
        if (!(
          /^.*[A-Za-z0-9].*/.test(filename) &&
          !/[;#,^'"]/gi.test(filename) &&
          this.acceptedExtensions.indexOf(extN.toLowerCase()) !== -1
        )) {
          file.error = true;
          this.$refs.fileListUploaded.value = '';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Apenas tipos de arquivo listados. Esses caracteres especiais não são permitidos: ; ^ # \' " e vírgulas.' : 'Listed file types only. These special characters are not allowed:  ;  ^  #  \'  " and commas.',
            group: 'custom-notification'
          });
        }
        if (!(
          Math.round(file.size / 1024) < 2 * 1024
        )) {
          file.error = true;
          this.$refs.fileListUploaded.value = '';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? `${file.name} O tamanho do arquivo excede 2 MB.` : `${file.name} size exceeds 2 MB`,
            group: 'custom-notification'
          });
        }
      });
      if (!fileList.length) return;
      fileList = fileList.filter((file) => !file.error);
      this.uploadedFiles = this.uploadedFiles.concat(...fileList);
      this.$refs.fileListUploaded.value = '';
      this.checkUpdatedFields();
    },
    openFileUpload() {
      $('#uploadFiles').click();
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
    },
    getDroppedFile(event) {
      const selectedFile = [...event.dataTransfer.files];
      this.filesUploaded(selectedFile);
    },
    goToDashboard() {
      this.$router.push('layout/dashboard');
    },
    checkUpdatedFields() {
      if (this.formData.subject === '' || this.formData.message === '' || this.uploadedFiles?.filter((file) => file.error).length > 0 || this.uploadedFiles?.length > 5) {
        this.disableSaveButton = true;
        return;
      }

      if (this.$v.formData.$invalid) {
        this.disableSaveButton = true;
        return;
      }
      this.disableSaveButton = false;
    },
    async submitForm() {
      this.loaderStatus = true;
      const formData = new FormData();
      this.uploadedFiles.forEach((item) => {
        formData.append('attachment', item);
      });
      formData.append('subject', this.formData.subject);
      formData.append('message', this.formData.message);
      const response = await saveSupportForm(formData);
      if (response.status_code === 200) {
        this.loaderStatus = false;
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Obrigado por entrar em contato conosco. Sua consulta será respondida por um de nossos especialistas em produtos em breve.' : 'Thank you for reaching out to us. Your query will be answered by one of our product experts soon.',
          group: 'custom-notification',
        });
        this.$router.push('layout/dashboard');
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Falha ao salvar dados' : 'Failed to save data',
          group: 'custom-notification',
        });
      }
    },
    sortAddresses(type, direction) {
      if (direction === 1) this.uploadedFiles.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.uploadedFiles.sort((a, b) => {
          const nameA = a[type].toUpperCase(); // ignore upper and lowercase
          const nameB = b[type].toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      }
    }
  },

};
</script>

<style scoped>
.pr-32 {
  padding-right: 32px;
}
.address-images {
    width:24px;
    height:24px
}
.pr-6 {
    padding-right:6px;
}
.attachments-label {
    color:  #333;
    font-family: Open Sans;
    font-size: 18px;
    font-weight: 600;
    padding-top:24px;
    padding-bottom: 24px;
}
 .btn-delete-file {
  background: none;
  color: #C02032 !important;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  }
.header-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}
.files-main {
  padding: 0px 32px 0px 8px;
}
#attachments_table {
  margin-bottom: 32px;
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.files-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding: 14px 0px 16px 12px !important;
}
.edit-icons{
  padding: 14px 24px 16px 12px !important;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 12px;
  column-gap: 7px
  /* justify-content: center; */
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

#attachmentsDataList th .arrow {
  opacity: 1;
}
#attachmentsDataList thead,

#attachmentsDataList tbody,

#attachmentsDataList tr:not(#attachmentsDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}

#ptb-0 {
    padding: 0px 0px 0px 18px !important;
 }
.file-header-text {
  font-size: 16px;
  color: #333;
  padding: 16px 0;
}
.upload-area {
  min-height: 220px;
  padding: 24px 16px;
  border-radius: 3px;
  border: 1px solid #d3d3d3;
}
.login-input-box-without-icon:focus {
  /* border-color: #3E3E3E !important; */
  border: 1px solid #3E3E3E !important;
  box-shadow: none;
}

.form-group input{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #4D4D4D;
  padding-left: 11px;
  padding-top: 6px;
  padding-bottom: 6px;
  background: #FFFFFF;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
  /* display: block; */
  /* width: 100%; */
  height: 34px;

}
.form-control:focus {
    border-color: #4D4D4D !important ;
    /* -webkit-box-shadow: none; */
    box-shadow: none;
}
.form-control::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
/* identical to box height */
    color: #999999;

}
.message-box {
  min-height: 286px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #4D4D4D;
    padding-left: 12px;
    padding-top: 12px;
    /* padding-bottom: 6px; */
    background: #FFFFFF;
    border: 1px solid #4D4D4D;
    border-radius: 3px;
    resize: none;
}
.titles{
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  margin-bottom:0px
}
.lower-line {
  border-top: 1px solid #CCCCCD;
  margin: 16px 20px 16px 0px;
}
.lower-line-inside {
  border-top: 1px solid #CCCCCD;
  margin: 32px 32px 32px 8px;
}
.contacts_main {
  padding-left:24px;
  padding-right: 24px;
  background-color:#E5E5E5;
  min-height: calc(100vh - 50px) !important;
}
.support_title {
font-weight: 400;
font-size: 24px;
line-height: 34px;
color: #3E3E3E;
}
.content-body {
  padding-top:24px;
}
.support_form {
  background: #FFFFFF;
  border: 1px solid #B3B3B3;
}
.support_message {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #3E3E3E;
  padding: 8px 0 22px 0px;
}
.cancel_ul_button,
.cancel_ul_button:hover {
  background: rgba(230, 230, 230, 0.5);
  border-radius: 3px;
  /* border: 1px solid #000001; */
  min-height: 44px;
  width: auto;
  color: #404040;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 24px;
  /* float: right; */
  /* cursor: pointer; */
  padding: 10px 16px;
}
.save_ul_button,
.save_ul_button:hover {
  background-color: #01518A ;
  border-radius: 3px;
  /* border: 1px solid #000001; */
  min-height: 44px;
  min-width: 101px;
  color: #FFFFFF !important;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 24px;
  padding: 10px 16px 10px 16px ;
}
.notify_message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding: 0px 10px;
}
.ml-30 {
  margin-left: 30px;
}
.mt-32 {
  margin-top: 32px;
}
.pl-8 {
  padding-left:8px
}
.pb-7 {
  padding-bottom:7px
}
.pb-8 {
  padding-bottom:8px
}
.pb-38 {
  padding-bottom: 42px;
}
.pr-17 {
  padding-right: 17px;
}
.pr-4 {
  padding-right: 4px;
}
.pb-16 {
  padding-bottom: 16px;
}
.col-gap-16 {
  column-gap: 16px;
}
.custom-error-class{
  margin-top: 0px;
  padding-top: 9px;
  color: #E12D33;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
}
.invalid-border {
  border-color: #E12D33 !important;
}
@media screen and (max-width: 1300px) {
  .contacts_main {
    min-height: 100vh !important;
  }

}
</style>
